function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import * as DetailUtils from '@shared/utils/detailUtils';
import { Constants } from '@shared/utils/constants';
import { mergeStyles } from '@fluentui/react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
export const TAB_SELECTED = 'tabSelected';
export const DEFAULT_TAB = 'defaultTab';
export const SELECTED_TAB_QUERY = `.${DEFAULT_TAB}.${TAB_SELECTED}`;
export class Tab extends SpzaComponent {
    renderImpl() {
        return this.props.children;
    }
}
const tabsClass = mergeStyles({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
});
export var TabsTheme = /*#__PURE__*/ function(TabsTheme) {
    TabsTheme[TabsTheme["gray"] = 0] = "gray";
    return TabsTheme;
}({});
export class Tabs extends SpzaComponent {
    changeTabWithName(e, name) {
        e.preventDefault();
        const detailsObject = {
            tab: name
        };
        DetailUtils.generateClickPayloadAndLogTelemetry(this.props.ownerType, this.props.ownerId, Constants.Telemetry.ActionModifier.Tab, detailsObject);
        this.props.changeTabCallback(name);
    }
    getCurrentTabIndex() {
        const tabsList = this.getNonNullChildren();
        const length = tabsList.length;
        for(let index = 0; index < length; index++){
            const tab = tabsList[`${index}`].valueOf();
            if (tab.props.name === this.props.defaultTab) {
                return index;
            }
        }
        return 0;
    }
    getHeaderElement(currentTabIndex) {
        const { getTabHref } = this.props;
        return function(child, index) {
            var _child_props;
            const classes = classNames({
                [TAB_SELECTED]: currentTabIndex === index,
                [DEFAULT_TAB]: true
            });
            if (child === null || child === void 0 ? void 0 : (_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.children) {
                const otherProps = child.props.otherProps || {};
                const { name, title, textBadge } = child.props;
                return /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
                    to: getTabHref(name),
                    className: classes,
                    role: "tab",
                    "aria-selected": currentTabIndex === index,
                    onClick: (e)=>{
                        this.changeTabWithName(e, name);
                    }
                }, otherProps), {
                    children: textBadge ? /*#__PURE__*/ _jsxs("label", {
                        children: [
                            title,
                            " ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "tabTextBadge",
                                children: textBadge
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx("label", {
                        children: title
                    })
                }), 'tab' + index);
            } else {
                return null;
            }
        };
    }
    getNonNullChildren() {
        return React.Children.toArray(this.props.children);
    }
    // Returns the number of non-null children.
    getNonNullChildrenCount() {
        return this.getNonNullChildren().length;
    }
    shouldRenderHeader() {
        return this.getNonNullChildrenCount() > 1;
    }
    renderHeaders(currentTabIndex) {
        // we do not render a header if there's only one tab
        if (!this.shouldRenderHeader()) {
            return null;
        } else {
            const createHeaderElement = this.getHeaderElement(currentTabIndex);
            const tabClass = classNames({
                [tabsClass]: this.props.centerize
            });
            return /*#__PURE__*/ _jsx("div", {
                className: tabClass,
                children: this.getNonNullChildren().map(createHeaderElement.bind(this))
            });
        }
    }
    renderImpl() {
        const currentTabIndex = this.getCurrentTabIndex();
        const tabContainerClass = 'tabContainer ' + (this.props.theme === 0 ? 'gray' : '');
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: tabContainerClass,
                    role: "tablist",
                    "aria-busy": "true",
                    children: this.renderHeaders(currentTabIndex)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "tabContent",
                    children: this.getNonNullChildren()[`${currentTabIndex}`]
                })
            ]
        });
    }
}
Tab.contextTypes = {
    renderErrorModal: PropTypes.func
};
Tabs.contextTypes = {
    renderErrorModal: PropTypes.func
};
